<div class="flex-container" *ngIf="isLoggedIn">
    <div class="nameSpaceBox" *ngIf="lastLogin">
        <span class="small">Last logged at: {{lastLogin | date: 'medium'}}</span>
    </div>
    <div class="nameSpaceBox" *ngIf="isRoleSelectionShown">
        <a (click)="onChangeRoleClick()">
            <span *ngIf="userRoleName">Role: {{userRoleName}}</span>
        </a>
    </div>
    <div class="nameSpaceBox" *ngIf="userName">
        {{userName}}
    </div>
    <div class="nameSpaceBox last" *ngIf="companyName">
        {{companyName}}
    </div>
    <div id="logout-user" (click)="logout()" class="logout-icon">
        <a>
            <img src="assets/images/logout.svg">
        </a>
    </div>
</div>